/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-thumbs-down': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.725 13.125a2.275 2.275 0 002.025-2.5v-3.75c0-2.281-.975-5-5.625-5H1.25v8.75h4.037L7.5 13.981l.625 3.963v.075c.097.419.464.72.894.731H10a2.275 2.275 0 002.5-2.5v-3.125h3.75c.158.019.317.019.475 0zM5 9.375H2.5v-6.25H5v6.25zm12.5 1.25c0 .9-.35 1.25-1.25 1.25h-5v4.375c0 .9-.35 1.25-1.25 1.25h-.706l-.088-.625-.456-3.356-2.5-3.707V3.125h6.875c2.988 0 4.375 1.194 4.375 3.75v3.75z"/>'
  }
})
